import React, { useEffect, useState } from 'react'
import { Button, BUTTON_THEME, CheckBox, Input, Select } from '@st-operations/uikit/src/v2'
import toast from '@st-operations/uikit/lib/toast'

import { logErrorAsync } from '_lib/utility'
import { getDaasClients } from '_services/daas-clients'
import { getEventsSchema } from '_services/data-explorer'
import WelcomeIllustration from './welcome-illustration.svg'

import './styles.scss'
import { TYPE_PREBUILT_ATTRIBUTES_V2 } from '..'

const body = document.querySelector('body')

const EventFeedsWizardWelcome = ({
  namelessFeed,
  onStartClick,
  dontShowMore,
  onDontShowMoreChange,
  feedName,
  onFeedNameChange,
  type,
  onTypeChange,
  client,
  onClientChange,
  onCreateWithoutWizard,
}) => {
  const [allClients, setAllClients] = useState([])
  const [allTypes, setAllTypes] = useState([])

  useEffect(() => {
    async function fetch() {
      const { type } = await getEventsSchema()
      setAllTypes(type.enum)
      onTypeChange(type.enum[0].value)
    }
    fetch()
  }, [])

  useEffect(() => {
    async function getEnums() {
      try {
        const allClients = await getDaasClients(['_id', 'name'])

        setAllClients(allClients.items)
      } catch (error) {
        logErrorAsync(error)
        toast.error(error.message)
      }
    }
    getEnums()
  }, [])

  return (
    <div className="event-feeds-wizard-welcome__container">
      <div className="event-feeds-wizard-welcome__content-container">
        <WelcomeIllustration
          width={namelessFeed ? undefined : 100}
          height={namelessFeed ? undefined : 100}
        />
        <h3 className="event-feeds-wizard-welcome__title">Welcome to Data Explorer!</h3>
        <span className="event-feeds-wizard-welcome__description">{`Data Explorer helps you understand the interests of consumers using data built from analyzing people's daily interactions with internet content.`}</span>
        <If condition={!namelessFeed}>
          <Input
            label="Feed Name"
            name="Feed Name"
            onChange={(value) => onFeedNameChange(value)}
            value={feedName}
          />
          <Select
            style={{ width: '100%' }}
            isSearchable={true}
            label="Client"
            name="Client"
            onChange={(_, _2, value) => onClientChange(value)}
            options={allClients}
            useReactSelect={true}
            value={client}
            menuPosition="fixed"
            menuPortalTarget={body}
            styles={{ menuPortal: (provided) => ({ ...provided, zIndex: 9999, maxHeight: 200 }) }}
          />
        </If>
      </div>
      <div className="event-feeds-wizard-welcome__bottom-section">
        <If condition={namelessFeed}>
          <CheckBox
            className="event-feeds-wizard-welcome__do-not-show-check"
            label="I do not wish to see this again"
            checked={dontShowMore}
            onChange={onDontShowMoreChange}
          />
        </If>
        <If condition={!namelessFeed}>
          <div />
        </If>
        <div className="event-feeds-wizard-welcome__buttons-section">
          <If condition={!namelessFeed && type !== TYPE_PREBUILT_ATTRIBUTES_V2}>
            <Button
              className="event-feeds-wizard-welcome__start-button"
              onClick={onCreateWithoutWizard}
              disabled={!namelessFeed && (!feedName || !client)}
              theme={BUTTON_THEME.SECONDARY}
            >
              Create Without Wizard
            </Button>
          </If>
          <Button
            className="event-feeds-wizard-welcome__start-button"
            onClick={onStartClick}
            disabled={!namelessFeed && (!feedName || !client)}
          >
            <If condition={type !== TYPE_PREBUILT_ATTRIBUTES_V2}>Start Wizard</If>
            <If condition={type === TYPE_PREBUILT_ATTRIBUTES_V2}>Go to Feed</If>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default EventFeedsWizardWelcome
